import type { ReactElement } from 'react';
import { GUARDIAN_MARKED_COMPONENTS, GuardianErrorComponent } from './GuardianMarkdown';

/**
 * Resolves a UI component by name from the chat tool registry. Shared by every surface
 * that renders backend-named components: chat panels and dashboard leaf nodes.
 */
export const renderUIComponent = (componentName: string, params: unknown): ReactElement => {
  const Component = GUARDIAN_MARKED_COMPONENTS[componentName];
  if (!Component) {
    console.error(`No UI component found for: ${componentName}`);
    return <GuardianErrorComponent />;
  }
  return <Component params={params} />;
};
